import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { paths } from '@constants/paths';
import { SnackbarVariant, useSnackbar } from '@hooks/useSnackbar';
import { useAppointmentContext } from '@providers/AppointmentProvider/AppointmentContext';

const useDepositPrivacySnackbar = () => {
  const snackbar = useSnackbar();

  const location = useLocation();
  const { hasControl, isSyncedAppointment } = useAppointmentContext();

  useEffect(() => {
    const isDepositPage = location.pathname === paths.deposit;

    if (isDepositPage && isSyncedAppointment && !hasControl) {
      snackbar({
        message: "Only the customer can see what they're typing",
        variant: SnackbarVariant.Error,
        preventDuplicate: true,
        persist: true,
      });
    }
  }, [isSyncedAppointment, hasControl, location.pathname, snackbar]);
};
export { useDepositPrivacySnackbar };
